import { AngularInjector } from '../../../../common/AngularUtils';

OrganizationPreferenceService.useInstance = () =>
    AngularInjector.useInjectedClass(OrganizationPreferenceService);
OrganizationPreferenceService.$inject = ['organizationService'];
export default function OrganizationPreferenceService(organizationService) {
    this.get = () => {
        return organizationService.getOrgSettings();
    };

    this.getOrg = () => {
        return organizationService.get();
    };

    this.update = (orgPreferenceId, orgPreferences) => {
        const properties = {};
        if ('restrictTeamManagement' in orgPreferences) {
            properties['sf_restrictTeamManagement'] = orgPreferences.restrictTeamManagement;
        }
        if ('alertAutoClearDuration' in orgPreferences) {
            properties['sf_alertAutoClearDuration'] = orgPreferences.alertAutoClearDuration;
        }
        if ('defaultTokenExpiration' in orgPreferences) {
            properties['sf_defaultTokenLifespanMs'] = orgPreferences.defaultTokenExpiration;
        }
        if ('userSessionDuration' in orgPreferences) {
            properties['sf_userSessionDurationMs'] = orgPreferences.userSessionDuration;
        }
        if ('relatedContentLogsDisabled' in orgPreferences) {
            properties['sf_relatedContentLogsDisabled'] = orgPreferences.relatedContentLogsDisabled;
        }
        if ('aiAssistant' in orgPreferences) {
            properties['sf_ai_assistant_enabled'] = orgPreferences.aiAssistant;
        }
        if ('aiAssistantShareData' in orgPreferences) {
            properties['sf_ai_assistant_customer_data_usage_enabled'] =
                orgPreferences.aiAssistantShareData;
        }
        if ('defaultSsoRole' in orgPreferences) {
            properties['sf_orgDefaultRole'] = orgPreferences.defaultSsoRole;
        }
        if ('splunkIdpFallbackEnabled' in orgPreferences) {
            properties['sf_splunkIdpFallbackEnabled'] = orgPreferences.splunkIdpFallbackEnabled;
        }
        if ('logsRCMappingsConsumptionConfiguration' in orgPreferences) {
            properties['sf_logsRCMappingsConsumptionConfiguration'] =
                orgPreferences.logsRCMappingsConsumptionConfiguration;
        }
        if ('playgroundDisabled' in orgPreferences) {
            properties['sf_playgroundDisabled'] = orgPreferences.playgroundDisabled;
        }
        return organizationService.updateOrgSettings(orgPreferenceId, properties);
    };
}
